

export const selectNextTicket = (ticket, visibleTickets, callback) => {
    console.log('selectNextTicket called with:', {
        ticket,
        ticketsCount: visibleTickets?.length,
        visibleTickets,
        currentTicketId: ticket?.ticketId
    });
    
    let currentTicketPos = null;
    visibleTickets?.map(({ ticketId }, index) => {
        if (ticketId === ticket?.ticketId) {
            currentTicketPos = index;
            console.log('Found current ticket at position:', currentTicketPos);
            return currentTicketPos;
        } else {
            return "";
        }
    });

    console.log('After search:', { currentTicketPos, totalTickets: visibleTickets?.length });

    if (currentTicketPos !== null && visibleTickets?.length > 1) {
        let nextTicket = visibleTickets?.[currentTicketPos + 1];

        if (currentTicketPos === visibleTickets?.length - 1) {
            console.log('At last ticket, selecting previous ticket instead');
            nextTicket = visibleTickets?.[visibleTickets?.length - 2];
        }

        console.log('Selected next ticket:', { 
            nextTicketId: nextTicket?.ticketId,
            position: currentTicketPos + 1
        });

        callback(nextTicket, ticket?.ticketId);
    } else {
        console.log('No next ticket found, returning null');
        callback(null, ticket?.ticketId);
    }
};
